import {
    Component, OnInit 
} from '@angular/core';

import { HttpService } from '../../services/http.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CfAlertService } from '@crediblefinance/credible-ui';

@Component({
    selector: 'app-credit-card',
    templateUrl: './credit-card.component.html',
    styleUrl: './credit-card.component.scss'
})
export class CreditCardComponent implements OnInit {
    loading: boolean = false;
    status: string = 'loading';

    constructor(
        public httpService: HttpService,
        private cfAlertService: CfAlertService
    ) { }

    ngOnInit(): void {
        this.getPreRegisteredCardInfo();
    }

    getPreRegisteredCardInfo() {
        this.httpService.getPreRegisteredCardInfo().subscribe((res: any) => {
            this.loading = false;

            this.status = res.data ? 'registered' : 'not_registered';
        }, (err: HttpErrorResponse) => {
            this.status = 'not_registered';
        });
    }

    preregisterCard() {
        this.loading = true;

        this.httpService.preRegisterCard().subscribe((res: any) => {
            this.loading = false;

            this.cfAlertService.showSuccess(res.message);

            this.status = 'registered';
        }, (err: HttpErrorResponse) => {
            this.loading = false;
            this.cfAlertService.showError(err);
        });
    }
}